var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeIconDis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_355",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_12",
    x: 4.601,
    y: 4.6,
    width: 32.799,
    height: 32.799,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RZWS",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_355)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_355-2",
    "data-name": "Pfad 355",
    fill: "#f5f5f5",
    d: "M18,2A16,16,0,1,1,2,18,16.047,16.047,0,0,1,18,2m0-2A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_12)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_12-2",
    "data-name": "Vereinigungsmenge 12",
    className: "cls-1",
    d: "M 13.188 26.907 h 2 v 2 H 13.188 z m -4 2 h 2 v -2 H 9.188 z m 12.056 0 h 2 v -2 h -2 z m 4 0 h 2 v -2 h -2 z M 19.171 25.553 v 3.33 h -2 v -3.33 H 9.216 v -2 h 7.955 v -2.709 c -3.911 -0.309 -6.954 -2.51 -6.954 -5.175 a 4.272 4.272 0 0 1 1.733 -3.268 a 2.938 2.938 0 0 1 -0.175 -0.992 A 3.694 3.694 0 0 1 13.68 8.383 a 2.2 2.2 0 0 1 -0.151 -0.8 c 0 -1.737 2.013 -3.1 4.583 -3.1 s 4.583 1.363 4.583 3.1 a 2.189 2.189 0 0 1 -0.15 0.794 a 3.7 3.7 0 0 1 1.9 3.028 a 2.937 2.937 0 0 1 -0.174 0.992 a 4.272 4.272 0 0 1 1.733 3.268 c 0 2.638 -2.983 4.82 -6.837 5.164 v 2.72 h 8.045 v 2 z m -2 -5.712 v -3.663 L 14.88 13.883 l 0.708 -0.7 l 1.584 1.584 V 13.539 h 2 v 3.023 l 1.532 -1.531 l 0.707 0.707 l -2.24 2.238 v 1.854 c 3.3 -0.313 5.837 -2.057 5.837 -4.161 a 3.457 3.457 0 0 0 -1.64 -2.7 a 0.5 0.5 0 0 1 -0.151 -0.631 a 2.033 2.033 0 0 0 0.232 -0.924 a 2.934 2.934 0 0 0 -1.8 -2.4 a 0.5 0.5 0 0 1 -0.183 -0.71 a 1.324 1.324 0 0 0 0.228 -0.715 c 0 -1.14 -1.64 -2.1 -3.583 -2.1 s -3.583 0.964 -3.583 2.1 a 1.317 1.317 0 0 0 0.228 0.715 a 0.5 0.5 0 0 1 -0.182 0.71 a 2.935 2.935 0 0 0 -1.8 2.4 a 2.034 2.034 0 0 0 0.233 0.924 a 0.5 0.5 0 0 1 -0.151 0.631 a 3.457 3.457 0 0 0 -1.64 2.7 c 0 2.129 2.6 3.89 5.954 4.172",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeIconDis);
export default __webpack_public_path__ + "static/media/tree-icon-dis.b14b30f688eaf90ab22bb982c1d9fae1.svg";
export { ForwardRef as ReactComponent };